'use client';

import { catchError, type ErrorInfo } from 'next/error';

import { useTranslation } from '@cms/i18n/client';
import { Alert, AlertSeverity } from '@common/atoms/Alert';

import { useErrorLogger } from '../../hooks/useErrorLogger';

interface Props {
    title: string;
    hideAlert?: boolean;
}

function ErrorFallback(props: Props, { error }: ErrorInfo) {
    const __components = useTranslation('components').t;
    useErrorLogger(error, 'ComponentErrorBoundary');

    if (props.hideAlert) {
        return null;
    }

    return (
        <Alert hasIcon severity={AlertSeverity.INFO}>
            <p>
                {__components('boundaryError.title', {
                    title: __components(props.title),
                })}
            </p>
        </Alert>
    );
}

export const ComponentErrorBoundary = catchError(ErrorFallback);
